import React from 'react';
import { Link, useLocation } from '@tanstack/react-router';
import { IoChevronBack } from "react-icons/io5";
import { settingMenuItems } from './settinglinks';

const SettingsSidebar = () => {
  const location = useLocation();

  return (
    <aside className="w-[262px] min-h-screen bg-[#FAFAFA] border-r border-[#EEEEEE]">
      <nav className="flex flex-col h-full">
        <div className="flex bg-[#FFFFFF] h-[49px] items-center border-b border-[#EEEEEE] px-[12px]">
          <Link
            to="/"
            className="flex items-center gap-2 text-[#222222] hover:text-[#000000]"
          >
            <IoChevronBack className="w-4 h-4" />
            <span className="text-[14px] font-semibold ">Settings</span>
          </Link>
        </div>

        <div className="flex flex-col p-[12px]">
          <nav className="space-y-1">
            {settingMenuItems.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                className={`flex items-center w-full px-[12px] py-[8px] rounded-[8px] transition-colors duration-200 ${
                  location.pathname === item.path
                    ? 'bg-[#F5F5F5] text-[#222222] font-normal'
                    : 'text-[#222222] hover:bg-[#F5F5F5]'
                }`}
              >
                <item.icon className="w-[18px] h-[18px] text-[#7A7A7A] mr-[8px]" />
                <span className="text-[14px] ">{item.label}</span>
              </Link>
            ))}
          </nav>
        </div>
      </nav>
    </aside>
  );
};

export default SettingsSidebar;